import React from 'react';
import DestimeTopActionItem from './DestimeTopActionItem';

const DestimeTopActionsCard = ({ destimeTopActions, formatDuration }) => {
  return (
    <div className="bg-card rounded-lg shadow-gaming-md p-4 md:p-6">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4">많이 한 행동</h3>
      <div className="space-y-3">
        {(destimeTopActions || []).length === 0 ? (
          <div className="text-sm text-muted-foreground caption">아직 인증 기록이 없습니다.</div>
        ) : (
          (destimeTopActions || []).map((action, index) => (
            <DestimeTopActionItem
              key={`${action?.title}-${index}`}
              action={action}
              index={index}
              formatDuration={formatDuration}
            />
          ))
        )}
      </div>
    </div>
  );
};

export default DestimeTopActionsCard;
